import {addPaginationButtons} from 'snippets/pagniation-buttons/pagination-buttons';

const PRODUCT_CARD_PADDING = 16;
const SCROLL_SECTION_PADDING = 48;
const PRODUCT_CARD_SELECTOR = '.product-card-item';

class ProductCarousel extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const pageSection = this.dataset.pageSection;
        const config = {
            paginationContainer: '.pagination-container',
            scrollSection: '.scroll-section',
            pageSection: `.${pageSection}`,
            productCard: PRODUCT_CARD_SELECTOR,
            productCardPadding: PRODUCT_CARD_PADDING,
            scrollSectionPadding: SCROLL_SECTION_PADDING
        };
        this.adjustProductCardSize();
        this.setUpDragAndDrop();
        addPaginationButtons(config);

        window.addEventListener('resize', () => {
            this.adjustProductCardSize();
            this.setUpDragAndDrop();
            addPaginationButtons(config);
        });
    }

    setUpDragAndDrop() {
        const scrollSection = this.querySelector('.scroll-section');
        let isDown = false;
        let startX;
        let scrollLeft;
        let isDragging = false;

        scrollSection.addEventListener('mousedown', (e) => {
            isDown = true;
            isDragging = false;
            scrollSection.classList.add('active');
            startX = e.pageX - scrollSection.offsetLeft;
            scrollLeft = scrollSection.scrollLeft;
        });

        scrollSection.addEventListener('mouseleave', () => {
            isDown = false;
            scrollSection.classList.remove('active');
        });

        scrollSection.addEventListener('mouseup', () => {
            isDown = false;
            scrollSection.classList.remove('active');
        });

        scrollSection.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            isDragging = true;
            const x = e.pageX - scrollSection.offsetLeft;
            const walk = (x - startX) * 3; // Adjust the scroll speed (lower value for slower scroll)
            scrollSection.scrollTo({
                left: scrollLeft - walk,
                behavior: 'smooth'
            });
        });

        scrollSection.querySelectorAll('img').forEach(img => {
            img.addEventListener('mousedown', (e) => {
                e.preventDefault();
            });
        });

        scrollSection.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', (e) => {
                if (isDragging) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                }
            });
        });
    }

    adjustProductCardSize() {
        const carouselInner = this.querySelector('.scroll-section');
        const computedStyle = getComputedStyle(carouselInner);

        const paddingLeft = parseInt(computedStyle.paddingLeft, 10);
        const paddingRight = parseInt(computedStyle.paddingRight, 10);

        const gap = parseInt(computedStyle.gap, 10);
        const totalPadding = paddingLeft + paddingRight;

        const cardWidth = 240;
        const buffer = 10;
        const availableWidth = window.innerWidth - totalPadding - buffer;
        const cardCount = Math.floor((availableWidth + gap) / (cardWidth + gap));

        const columnWidth = Math.max(100 / (cardCount + 0.5), 17);
        carouselInner.style.gridAutoColumns = `calc(${columnWidth}%)`;
    }
}

customElements.define('product-carousel', ProductCarousel);


